var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwiadekPrzemocy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1766473091555936624 1",
    clipPath: "url(#clip0_66_4038)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outlined"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Maps"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outlined-/-Maps-/-person_pin_circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x94\xB9-Icon-Color",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0C2.6925 0 0 2.6925 0 6C0 10.1775 5.22 16.005 5.445 16.2525L6 16.8675L6.555 16.2525C6.78 16.005 12 10.1775 12 6C12 2.6925 9.3075 0 6 0ZM6 14.6025C4.365 12.645 1.5 8.655 1.5 6C1.5 3.5175 3.5175 1.5 6 1.5C8.4825 1.5 10.5 3.5175 10.5 6C10.5 8.8725 7.3125 13.02 6 14.6025ZM6 6C6.6225 6 7.125 5.4975 7.125 4.875C7.125 4.2525 6.6225 3.75 6 3.75C5.3775 3.75 4.875 4.26 4.875 4.875C4.875 5.4975 5.3775 6 6 6ZM6 6.75C5.25 6.75 3.75 7.125 3.75 7.875V7.965C4.2975 8.595 5.1 9 6 9C6.9 9 7.7025 8.595 8.25 7.965V7.875C8.25 7.125 6.75 6.75 6 6.75Z",
    fill: "white"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_66_4038"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 17.25,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwiadekPrzemocy);
export default __webpack_public_path__ + "static/media/swiadek_przemocy.5a02cd37aa7db86c684afb8640330115.svg";
export { ForwardRef as ReactComponent };